import { __ } from "@wordpress/i18n";
import { PanelBody, SelectControl, RangeControl } from "@wordpress/components";

const ANIMATION_OPTIONS = [
  { label: __("Fade", "brandy-blocks"), value: "fade" },
  { label: __("Slide", "brandy-blocks"), value: "slide" },
  { label: __("Scale", "brandy-blocks"), value: "scale" },
  { label: __("None", "brandy-blocks"), value: "none" },
];

export default function AnimationSettings({ attributes, setAttributes }) {
  const {
    animationType = "fade",
    animationDuration = 300,
  } = attributes;

  return (
    <PanelBody
      title={__("Animation", "brandy-blocks")}
      initialOpen={false}
    >
      <SelectControl
        label={__("Animation Type", "brandy-blocks")}
        value={animationType}
        options={ANIMATION_OPTIONS}
        onChange={(value) => setAttributes({ animationType: value })}
      />
      <RangeControl
        label={__("Duration (ms)", "brandy-blocks")}
        value={animationDuration}
        onChange={(value) => setAttributes({ animationDuration: value })}
        min={0}
        max={2000}
        step={50}
      />
    </PanelBody>
  );
}
